// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2shlw","error":"Textarea_error__2eE7q","readonly":"Textarea_readonly__2BnQT","disabled":"Textarea_disabled__27sfl"};